import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  MANAGE_SUBS_RESET_SUBSTITUTE_PRODUCTS,
} from './constants';

export function resetSubstituteProducts() {
  return {
    type: MANAGE_SUBS_RESET_SUBSTITUTE_PRODUCTS,
  };
}

export function useResetSubstituteProducts() {
  const dispatch = useDispatch();
  const substituteProducts = useSelector(state => state.manageSubs.substituteProducts);
  const boundAction = useCallback((...params) => dispatch(resetSubstituteProducts()), [dispatch]);
  return { substituteProducts, resetSubstituteProducts: boundAction };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_RESET_SUBSTITUTE_PRODUCTS:
      return {
        ...state,
        substituteProducts: null,
      };

    default:
      return state;
  }
}
